export default __webpack_public_path__ + "static/media/icon_pp_history.3e491925.svg";